import {useGetCompanies} from 'hooks/swr';
import useParseURL from 'hooks/useParseURL';
import type {Company} from 'client';

export const useGetDefaultCompany = (): Company | undefined => {
  const {planId} = useParseURL();
  const {data: companies} = useGetCompanies({resourceId: planId});
  const defaultCompany = companies?.length ? companies.find((company) => company.isDefault) : undefined;
  return defaultCompany;
};
